import { Box, Flex } from 'styled-system/jsx';
import RightArrow from '@/common/assets/icons/arrowRightIcon.svg?react';
import Typography from '@/common/components/base/typography/Typography.tsx';
import { CardButtonPropsType } from '@/common/components/cardButton/CardButton.type.ts';
import StarImage from '@/modules/Statistics/assets/icons/Star.svg?react';

const CardButton = ({
  title,
  renderIcon,
  renderTag,
  hasArrow = true,
  cardProps,
  titleProps,
  subtitle,
  arrowColor,
  hasRate,
  starData,
}: CardButtonPropsType) => {
  const convertPersian = (n: number) => n.toLocaleString('fa-IR');
  return (
    <Flex
      backgroundColor="white"
      borderRadius="8px"
      shadow="cardShadow"
      padding="1rem"
      alignItems="center"
      justifyContent="space-between"
      cursor="pointer"
      {...cardProps}
    >
      <Flex alignItems="center" gap="1rem">
        {renderIcon ? <Box>{renderIcon()}</Box> : null}
        <Typography flexShrink={1} textStyle="b1" {...titleProps}>
          {title}{' '}
          {subtitle ? (
            <Typography display="inline-block" textStyle="b1" color="black-3">
              (اختیاری)
            </Typography>
          ) : null}
        </Typography>
      </Flex>

      <Flex alignItems="center" gap="16px">
        {renderTag?.()}
        {hasRate && (
          <Flex
            gap="6px"
            justifyContent="center"
            alignItems="center"
            padding="4px 8px"
            borderRadius="8px"
            backgroundColor="#FFF4CF"
          >
            <Typography color="#D9AA04" textStyle="b2" fontWeight="bold">
              {convertPersian(starData ?? 0)}
            </Typography>
            <StarImage width={12} height={12} />
          </Flex>
        )}
        {hasArrow ? (
          <RightArrow width={12} color={arrowColor ?? undefined} />
        ) : null}
      </Flex>
    </Flex>
  );
};

export default CardButton;
